var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global-container",attrs:{"id":"app"}},[_c('slideout-panel'),_c('notifications',{attrs:{"group":"saved","position":"center top"}}),_c('v-dialog'),(_vm.getCurrentUser)?_c('global-nav'):_vm._e(),_c('div',{staticClass:"body-container"},[(_vm.getCurrentUser)?_c('profile-bar'):_vm._e(),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }